import React, { useState } from "react";
import { API } from "../../config/api";

export default function SupplierCard({
  item,
  openImagePopup,
  handleLocationRedirect,
}) {
  const images = Array.isArray(item.images)
    ? item.images
    : typeof item.images === "string"
      ? item.images.split(",").filter((img) => img.trim() !== "")
      : [];

  const [currentImage, setCurrentImage] = useState(0);

  const imagePath = (img) =>
    `${API.BASE_URL}/uploads/${item.supplier_table}/${item.user_id}/${img}`;

  const nextImage = (e) => {
    e.stopPropagation();

    if (images.length <= 1) return;

    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = (e) => {
    e.stopPropagation();

    if (images.length <= 1) return;

    setCurrentImage((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  return (
    <div className="design-card">
      <div className="machine-img-container position-relative">
        <img
          src={
            images.length
              ? imagePath(images[currentImage])
              : "https://via.placeholder.com/400x300?text=No+Image"
          }
          className="designer-img"
          alt={item.name}
          style={{ cursor: "pointer" }}
          onClick={() =>
            openImagePopup(
              images[currentImage],
              item.user_id,
              images,
              item.supplier_table,
            )
          }
        />

        {images.length > 1 && (
          <>
            <button className="supNavArrow supNavArrowLeft" onClick={prevImage}>
              <i className="bi bi-chevron-left"></i>
            </button>

            <button
              className="supNavArrow supNavArrowRight"
              onClick={nextImage}
            >
              <i className="bi bi-chevron-right"></i>
            </button>

            {/* {currentImage + 1}/{images.length} */}
            {images?.length > 1 && (
              <div className="image-count">
                <i className="bi bi-images me-1"></i>+{images.length - 1}
              </div>
            )}
          </>
        )}
      </div>

      {images.length > 0 && (
        <div className="thumbnail-tray">
          {images.map((img, i) => (
            <img
              key={i}
              src={imagePath(img)}
              alt=""
              className={`card-thumbnail ${
                currentImage === i ? "active-thumb" : ""
              }`}
              onClick={() => {
                setCurrentImage(i);

                openImagePopup(
                  item.id,
                  img,
                  item.user_id,
                  images,
                  item.supplier_table,
                );
              }}
            />
          ))}
        </div>
      )}

      <div className="machine-body">
        <h4 className="machine-name">{item.name}</h4>

        {/* <div className="spec-row mt-2">
          <div className="spec-item">
            <span className="spec-label">Supplier :</span>

            <span className="spec-value">
              {item.supplier_name || item.supplier_table}
            </span>
          </div>
        </div> */}

        <div className="spec-row">
          <div className="spec-item">
            <span className="spec-label">Mobile :</span>

            <span className="spec-value">{item.mobile}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">Email :</span>

            <span className="spec-value">{item.email || ""}</span>
          </div>
        </div>

        <div className="mt-2">
          <button
            className="btn btn-link btn-sm p-0 text-decoration-none text-start"
            onClick={() => handleLocationRedirect(item.address)}
          >
            <i className="bi bi-geo-alt-fill text-danger me-1"></i>

            <span
              style={{
                color: "#1a2daa",
                fontWeight: "bold",
              }}
            >
              {item.address}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
